import React from "react";
import "./Footer.scss";
import { Section } from "../Section/Section";

const Footer = () => {
  return (
    <Section backgroundColor="#1f1f1f">
      <div className="footer">
        <p className="footer__text">
          Lucas Vinicius Ribeiro, owner of {" "}
          <span> <b>LVR SERVICES</b> | CNPJ (Register Number): 66.359.636/0001-32 </span>
        </p>
      </div>
    </Section>
  );
};

export default Footer;
